import React from 'react';
import { Navigate } from 'react-router-dom';
import { NavigationPathsEnum } from '@utilities/enums';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Login, OtpVerification, Dashboard, Profile, Users, Members, Orders, VisibilitySettings, AdminPricingSettings, OrderNotificationsSettings, LegalSettings, Payments } from '@pages';
import { useAuth } from '@data/contexts';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to={NavigationPathsEnum.LOGIN} replace />;
    }

    return <>{children}</>;
};

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isAuthenticated } = useAuth();

    if (isAuthenticated) {
        return <Navigate to={NavigationPathsEnum.DASHBOARD} replace />;
    }

    return <>{children}</>;
};

export const Navigations: React.FC = () => {
    const router = createBrowserRouter([
        {
            path: NavigationPathsEnum.LOGIN,
            element: <PublicRoute><Login /></PublicRoute>,
        },
        {
            path: NavigationPathsEnum.OTP_VERIFICATION,
            element: <PublicRoute><OtpVerification /></PublicRoute>,
        },
        {
            path: NavigationPathsEnum.DASHBOARD,
            element: <ProtectedRoute><Dashboard /></ProtectedRoute>,
        },
        {
            path: NavigationPathsEnum.PROFILE,
            element: <ProtectedRoute><Profile /></ProtectedRoute>,
        },
        {
            path: NavigationPathsEnum.USERS,
            element: <ProtectedRoute><Users /></ProtectedRoute>,
        },
        {
            path: NavigationPathsEnum.MEMBERS,
            element: <ProtectedRoute><Members /></ProtectedRoute>,
        },
        {
            path: NavigationPathsEnum.ORDERS,
            element: <ProtectedRoute><Orders /></ProtectedRoute>,
        },
        {
            path: NavigationPathsEnum.PAYMENTS,
            element: <ProtectedRoute><Payments /></ProtectedRoute>,
        },
        {
            path: NavigationPathsEnum.SETTINGS_VISIBILITY,
            element: <ProtectedRoute><VisibilitySettings /></ProtectedRoute>,
        },
        {
            path: NavigationPathsEnum.SETTINGS_PRICING,
            element: <ProtectedRoute><AdminPricingSettings /></ProtectedRoute>,
        },
        {
            path: NavigationPathsEnum.SETTINGS_NOTIFICATIONS,
            element: <ProtectedRoute><OrderNotificationsSettings /></ProtectedRoute>,
        },
        {
            path: NavigationPathsEnum.SETTINGS_LEGAL,
            element: <ProtectedRoute><LegalSettings /></ProtectedRoute>,
        },
        {
            path: '*',
            element: <Navigate to={NavigationPathsEnum.LOGIN} replace />,
        },
    ]);

    return <RouterProvider router={router} />;
};
